const FOOTER_GROUPS = [
  {
    id: 'f-1',
    title: '条线入口',
    links: [
      { href: '#topics', label: '话题墙' },
      { href: '#brief', label: '今夜速览' },
      { href: '#timeline', label: '关键时间线' },
      { href: '#dossiers', label: '条线档案' },
    ],
  },
  {
    id: 'f-2',
    title: '按类型看',
    links: [
      { href: '#topics', label: '塌房条线' },
      { href: '#topics', label: '翻车现场' },
      { href: '#topics', label: '争议焦点' },
      { href: '#topics', label: '丑闻档案' },
    ],
  },
  {
    id: 'f-3',
    title: '围观与说明',
    links: [
      { href: '#comments', label: '围观现场' },
      { href: '#entrances', label: '快捷入口' },
      { href: '#overview', label: '本站定位' },
      { href: '#brief', label: '避雷说明' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-foreground-950 px-4 pb-10 pt-16 text-background-50 md:px-8 md:pt-20">
      <div className="mx-auto w-full max-w-7xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-moon-fill text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                  深夜黑料
                </span>
                <span className="mt-1 font-label text-[10px] tracking-[0.28em] text-background-50/50">
                  LATE NIGHT ARCHIVE
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-50/65">
              专注做深夜黑料负面事件，把塌房、翻车、争议、丑闻按条线列成避雷，包含关键时间与最终结果。
              全站内容为静态示例展示，用于说明条线整理方式。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="flex items-center gap-2 rounded-full border border-background-50/15 px-3 py-1.5 text-xs text-background-50/70">
                <i className="ri-time-line text-base text-accent-300" />
                每日 00:00 更新
              </span>
              <span className="flex items-center gap-2 rounded-full border border-background-50/15 px-3 py-1.5 text-xs text-background-50/70">
                <i className="ri-list-check-2 text-base text-accent-300" />
                条线化整理
              </span>
            </div>
          </div>

          {FOOTER_GROUPS.map((group) => (
            <div key={group.id} className="lg:col-span-2">
              <h3 className="font-heading text-sm font-bold text-background-50">{group.title}</h3>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={`${group.id}-${link.label}`}>
                    <a
                      href={link.href}
                      className="text-xs text-background-50/60 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h3 className="font-heading text-sm font-bold text-background-50">关于</h3>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="#overview"
                  className="text-xs text-background-50/60 transition-colors hover:text-accent-300"
                >
                  站内说明
                </a>
              </li>
              <li>
                <a
                  href="#comments"
                  className="text-xs text-background-50/60 transition-colors hover:text-accent-300"
                >
                  讨论规则
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-50/45">
            深夜黑料 · 条线整理示例站点，内容均为虚构展示，不对应任何真实个人或事件。
          </p>
          <p className="font-label text-xs text-background-50/45">
            © {new Date().getFullYear()} LATE NIGHT ARCHIVE
          </p>
        </div>
      </div>
    </footer>
  );
}